import styled, { createGlobalStyle } from 'styled-components'

export const GlobalStyle = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    font-family: 'Inter', sans-serif;
    box-sizing: border-box;
  }

  #root {
    min-height: 100vh;
  }
`

// Tamanhos de tela com base em breakpoints comumente usados
export const sizes = {
  largeDesktop: 1400,
  desktop: 992,
  tablet: 768,
  phone: 576,
}

// Media queries para cada tamanho de tela
export const devices = {
  largeDesktop: `(min-width: ${sizes.largeDesktop}px)`,
  desktop: `(min-width: ${sizes.desktop}px) and (max-width: ${
    sizes.largeDesktop - 1
  }px)`,
  tablet: `(min-width: ${sizes.tablet}px) and (max-width: ${
    sizes.desktop - 1
  }px)`,
  phone: `(max-width: ${sizes.phone - 1}px)`,
}
